import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { NAV, MODAL_HIDE, MODAL_ORACLE_COLLECT_EMAILS, MODAL_SHOW } from '../../constants/action-types';
import Modal from 'react-responsive-modal';

class OracleComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: true
        }
    }

    componentDidMount() {

        // this.props.openOracleModal()

    }

    render() {
        return (
            <section id='oracle' className='content-section-wrap'>
                <div id='oracle-head' className='content-section-head'>
                    <h1 className='mvu-head xl'>Oracles</h1>
                </div>
                <div id='oracle-list-wrap' className='content-section'>
                    <h3>EARN ETH AND MVU WITHOUT THE RISK OF BETTING</h3>

                    <div className='oracle-section'>
                        <h4>What are Oracles?</h4>
                        <p>Oracles are users who choose to stake some of their MVU and
                            report the winners of popular events.</p>
                    </div>
                    {/* <ul> */}
                        <img src='/img/oracle.svg' alt='' />
                        {/* <div> */}
                            <div className='oracle-section'>
                                <h4>Who can be an Oracle?</h4>
                                <p>Anyone who holds some MVU tokens and has gone through our KYC/AML
                                service provider's vetting process may have one Ethereum address
                            verified as an Oracle.</p>
                            </div>
                            <div className='oracle-section'>
                                <h4>How are Oracles paid?</h4>
                                <p>Oracles recieve a percentage of the fees taken from matched bets
                                corresponding to the event they chose to 'oraclize'. As more bettors
                            depend on the Oracle's service the percentage of earned ETH increases.</p>
                            </div>
                            <div className='oracle-section'>
                                <h4>Why have Oracles?</h4>
                                <p>Using a system of Oracles helps to prevent reliance on a central repository of information for event outcomes.
                                This follows the design philosophy of Ethereum as a platform for "unstoppable apps".
                            </p>
                            </div>
                        {/* </div> */}
                    {/* </ul> */}
                </div>
            </section>);
    }
}

const mapStateToProps = (state) => state

const mapDispatchToProps = (dispatch) => ({
    // openOracleModal: () => dispatch({type: MODAL_SHOW, modal: MODAL_ORACLE_COLLECT_EMAILS}),
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(OracleComponent)


// WEBPACK FOOTER //
// ./src/components/general/Oracle.js